export interface PriceDto {
    readonly priceInCents: number,
    readonly initialPriceInCents: number,
    readonly priceLabel?: string,
    readonly priceDetails?: string,
    readonly showInitialPriceStrikethrough: boolean,
    readonly showFrom: boolean,
    readonly showByMonth: boolean,
    readonly showOdrPrice: boolean,
    readonly cheatCode: boolean,
    readonly saferPhone: boolean,
    readonly promotionType?: PromotionType,
    readonly duration: number,
}

export enum PromotionType {
    PROMO_DURATION = "PROMO_DURATION",
    PROMO_DURATION_FIRST_MONTHS = "PROMO_DURATION_FIRST_MONTHS",
    END_OF_PROMO = "END_OF_PROMO",
    UNTIL_END_OF_PROMO = "UNTIL_END_OF_PROMO",
    CHILDREN_PROMOTION = "CHILDREN_PROMOTION",
}
